import {EMPTY, expand, Observable, reduce} from 'rxjs';
import {map} from 'rxjs/operators';

export function fetchAllPaginated<T>(
  fetchPage: (offset: number, limit: number) => Observable<PagedResult<T>>,
  pageSize: number
): Observable<PagedResult<T>> {
  return fetchPage(0, pageSize).pipe(
    map(first => ({
      ...first,
      offset: 0
    })),

    expand(page => {
      const { paging, offset } = page;
      const total = paging.totalItems;

      const nextOffset = offset + pageSize;

      if (nextOffset < total) {
        return fetchPage(nextOffset, pageSize).pipe(
          map(next => ({
            ...next,
            offset: nextOffset
          }))
        );
      }

      return EMPTY;
    }),

    reduce((acc: PagedResult<T>, curr) => {
      return {
        list: [...(acc.list ?? []), ...(curr.list ?? [])],
        paging: {
          curItems: (acc.paging.curItems ?? 0) + curr.paging.curItems,
          offset: 0,
          totalItems: curr.paging.totalItems
        }
      };
    }, {
      list: [],
      paging: {
        curItems: 0,
        offset: 0,
        totalItems: 0
      }
    })
  );
}

export interface PagedResult<T> {
  list?: Array<T>;
  paging: {
    curItems: number;
    offset: number;
    totalItems: number;
  };
}
